import { EnumLegalEntityRole, LegalEntityBasicInfo } from "./legal-entity-basic-info";
import { EnumRoleFullIdentifier, EnumUserRole, UserBasicInfo } from "./user-basic-info";
import { UserLegalEntityDetail } from "./user-legal-entity-detail";
import { EnumUserLegalEntityRole, UserLegalEntityInfo } from "./user-legal-entity-info";

export class UserLegalEntityBasicDetail {
    userId: number | undefined;
    legalEntityId: number | undefined;
    userRoles: EnumUserRole[] | undefined;
    legalEntityRole: EnumLegalEntityRole | undefined;
    userLegalEntityRoles: EnumUserLegalEntityRole[] | undefined;

    getRolesFullIdentifiers(): EnumRoleFullIdentifier[] {
        const roleFullIdentifiers: EnumRoleFullIdentifier[] = [];
        if (
            this.userRoles &&
            this.legalEntityRole &&
            this.userLegalEntityRoles &&
            this.userRoles.length > 0 &&
            (this.legalEntityRole as string).length > 0 &&
            this.userLegalEntityRoles.length > 0
        ) {
            this.userRoles.forEach((userRole: EnumUserRole) => {
                if (userRole !== EnumUserRole.NONE) {
                    this.userLegalEntityRoles!.forEach((userLegalEntityRole: EnumUserLegalEntityRole) => {
                        if (
                            userLegalEntityRole !== EnumUserLegalEntityRole.NONE &&
                            this.legalEntityRole !== EnumLegalEntityRole.NONE
                        ) {
                            const roleFullIdentifier: EnumRoleFullIdentifier = `${userRole}.${this.legalEntityRole}.${userLegalEntityRole}` as EnumRoleFullIdentifier;
                            roleFullIdentifiers.push(roleFullIdentifier);
                        }
                    });
                }
            });
        } else if (this.userRoles && this.userRoles.length > 0) {
            this.userRoles.forEach((userRole: EnumUserRole) => {
                if (userRole !== EnumUserRole.NONE) {
                    const roleFullIdentifier: EnumRoleFullIdentifier = `${userRole}.NONE.NONE` as EnumRoleFullIdentifier;
                    roleFullIdentifiers.push(roleFullIdentifier);
                }
            });
        }
        return roleFullIdentifiers;
    }

    static fromUserLegalEntityDetail(userLegalEntityDetail: UserLegalEntityDetail): UserLegalEntityBasicDetail {
        const instance = new UserLegalEntityBasicDetail();
        instance.userId = userLegalEntityDetail.userInfo?.id;
        instance.legalEntityId = userLegalEntityDetail.legalEntityInfo?.id;
        instance.userRoles = userLegalEntityDetail.userInfo?.roles;
        instance.legalEntityRole = userLegalEntityDetail.legalEntityRole;
        instance.userLegalEntityRoles = userLegalEntityDetail.userLegalEntityRoles;
        return instance;
    }

    static fromUserLegalEntityInfo(userLegalEntityInfo: UserLegalEntityInfo, userRoles: EnumUserRole[]): UserLegalEntityBasicDetail {
        const instance = new UserLegalEntityBasicDetail();
        instance.userId = userLegalEntityInfo.userId;
        instance.legalEntityId = userLegalEntityInfo.legalEntityId;
        instance.userRoles = userRoles;
        instance.legalEntityRole = userLegalEntityInfo.legalEntityRole;
        instance.userLegalEntityRoles = userLegalEntityInfo.userLegalEntityRoles;
        return instance;
    }
}